/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { shippingAddressCreate, shippingAddressDelete, shippingAddressDetail, shippingAddressList, shippingAddressUpdate } from '../settings/apiconfig';
import interfaceService from './interfaceService';
import { getBuyerHeaders, getBuyersUrl } from 'shared/http';


class PersonalInfoService {
    constructor() {
        this.service = interfaceService.getService();
    }

    shippingAddressList(data) {
        return this.service.post(getBuyersUrl(shippingAddressList), JSON.stringify(data), getBuyerHeaders());
    }

    shippingAddressDetail() {
        return this.service.get(getBuyersUrl(shippingAddressDetail), getBuyerHeaders());
    }

    shippingAddressCreate(data) {
        return this.service.post(getBuyersUrl(shippingAddressCreate), JSON.stringify(data), getBuyerHeaders());
    }

    shippingAddressUpdate(data) {
        return this.service.put(getBuyersUrl(shippingAddressUpdate), JSON.stringify(data), getBuyerHeaders());
    }

    shippingAddressDelete() {
        return this.service.delete(getBuyersUrl(shippingAddressDelete), getBuyerHeaders)
    }
}

export default new PersonalInfoService();